export const templatesList = {
  newJobRequestTemplate: 'New Job Template',
  templateNameCol: 'Template Name',
  createdByCol: 'Created By',
  usageNumberCol: 'Times Used',
  lastUsageDateCol: 'Last Used',
  neverText: 'Never',
  confirmHeader: 'Please Confirm',
  confirmDelete: 'Are you sure you want to delete this template?',
  newJobBtn: 'New Job',
  editBtn: 'Edit',
  deleteBtn: 'Delete',
  noTemplates: 'No saved templates',
  noTemplatesBody: 'Your template page seems to be empty. Post a job and save that as a template.'
};

export const templates = {
  deleteTemplatesModal: {
    header: 'Delete Template',
    content: 'Are you sure you want to delete this template?  Deletion is a permenant action and can not be reversed.',
  },
  incompleteCard: {
    note: 'This template is missing important information.',
    ask: 'Please complete the template by clicking the edit button below.'
  }
};
